import React from 'react'
import { Layout, Showcase, Header } from '../../../../components'

import './style.scss'
import data from './data.json'
import changelog from '../../../../data/changelog.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        inProgress="true"
        category={data.category}
        changelog={changelog[data.title].changelog}
        description={data.description}
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
        updated={changelog[data.title].lastUpdated}
      >
        <Showcase
          site={data.site}
          title="Inline Error"
          text="Inline errors directly affect the input field that requires correction. The input's container will change color to draw the user's attention and a message below the input will give the user clear direction on how to resolve the error."
        >
          <div>
            <label class="c-label" htmlFor="label-1">
              Label Name
            </label>
            <input
              type="text"
              class="c-text-field c-inline-error__input"
              placeholder="e.g. Homer J. Simpson"
              id="label-1"
            />
            <span class="c-inline-error">
              <span class="c-inline-error__content">
                Please enter your full name.
              </span>
            </span>
          </div>
        </Showcase>
      </Layout>
    </>
  )
}
